var MigrationProgressStageModel = require( './MigrationProgressStage-model' );
var $ = jQuery;

var MigrationProgressModel = Backbone.Model.extend( {
	defaults: {
		_initialStages: null,
		stages: null,
		activeStageName: null,
		stageModels: null,
		localTableRows: null,
		localTableSizes: null,
		remoteTableRows: null,
		remoteTableSizes: null,
		migrationStatus: 'active',
		migrationIntent: 'savefile'
	},
	initialize: function() {
		this.set( 'stageModels', {} );
		this.set( '_initialStages', this.get( 'stages' ) );
		this.set( 'stages', [] );
		_.each( this.get( '_initialStages' ), function( stage, items, dataType ) {
			this.addStage( stage.name, items, dataType );
		}, this );
	},
	addStage: function( name, items, dataType, extend ) {
		var itemsArr = [];
		var stage;

		_.each( items, function( item ) {
			var size, rows;

			if ( 'remote' === dataType ) {
				size = this.get( 'remoteTableSizes' )[ item ];
				rows = this.get( 'remoteTableRows' )[ item ];
			} else {
				size = this.get( 'localTableSizes' )[ item ];
				rows = this.get( 'localTableRows' )[ item ];
			}

			itemsArr.push( {
				name: item,
				size: size,
				rows: rows
			} );
		}, this );

		stage = {
			name: name,
			items: itemsArr,
			dataType: dataType
		};

		if ( 'object' === typeof extend ) {
			stage = $.extend( stage, extend );
		}

		this.addStageModel( stage );

		this.trigger( 'stage:added', this.get( 'stageModels' )[ name ] );
		this.get( 'stageModels' )[ name ].on( 'change', function() {
			this.trigger( 'change' );
		}, this );

		return this.getStageModel( stage.name );
	},
	addStageItem: function( stage, name, size, rows, displayName = '' ) {
		this.getStageModel( stage ).addItem( name, size, rows, displayName );
	},
	addStageModel: function( stage ) {
		var stages = this.get( 'stages' );
		var stageModels = this.get( 'stageModels' );
		var newStageModel = new MigrationProgressStageModel( stage );

		stages.push( stage );
		stageModels[ stage.name ] = newStageModel;

		this.set( 'stages', stages );
		this.set( 'stageModels', stageModels );
	},
	getStageModel: function( name ) {
		return this.get( 'stageModels' )[ name ];
	},
	getStageItems: function( stage, map ) {
		var stageModel = this.getStageModel( stage );
		var items = stageModel.get( 'items' );

		if ( undefined === map ) {
			return items;
		} else {
			return items.map( function( item ) {
				return item[ map ];
			} );
		}
	},
	setActiveStage: function( stage ) {
		this.setStageComplete();
		this.set( 'activeStageName', stage );
		this.getStageModel( stage ).set( 'status', 'active' );
		this.trigger( 'change:activeStage' );
	},
	setStageComplete: function( stage ) {
		if ( ! stage ) {
			stage = this.get( 'activeStageName' );
		}
		if ( null !== stage ) {
			this.getStageModel( stage ).set( 'status', 'complete' );
		}

		wpmdb.current_migration.currentStageNum = wpmdb.current_migration.currentStageNum + 1;
	},
	setMigrationComplete: function() {
		var lastStage = this.getStageModel( this.get( 'activeStageName' ) );
		this.setStageComplete();
		this.trigger( 'migrationComplete' );
		this.set( 'migrationStatus', 'complete' );
		lastStage.activateTab();
	}
} );

module.exports = MigrationProgressModel;



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/modules/MigrationProgress-model.js